// extracted by mini-css-extract-plugin
module.exports = {"root":"Typography_root__nvhLo","h1":"Typography_h1__Zq2ad","h3":"Typography_h3__H_jnk","body1":"Typography_body1__HTeeJ","body2":"Typography_body2__xZCnj"};